var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"sellers@9c482a68cd5c1ba57cf4e206f57cacdcfe2af9ef"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sellers@riqra-pp"]={id:"sellers@9c482a68cd5c1ba57cf4e206f57cacdcfe2af9ef"};
      